import { Suspense, forwardRef, useImperativeHandle, useRef, useState } from "react"
import styled from "@emotion/styled"
import { AnimatePresence, motion, useAnimate, useAnimationControls } from "framer-motion"
import { createPortal } from "react-dom"
import { FocusScope } from "@react-aria/focus"

import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"

import { buttonReset } from "css/buttons"
import { bold } from "css/text"

import ModalContainer, { specTerms } from "components/modal/ModalContainer"
import { load, facetsMap } from "../utils"

const Button = styled.button`
  ${buttonReset};
  ${bold};
  margin-block-start: 0;

  color: rgb(var(--green));
  @media (hover: hover) {
    :hover {
      color: rgb(var(--light-black));
    }
  }
  .dark-theme & {
    color: inherit;
    @media (hover: hover) {
      :hover {
        color: rgb(var(--grey));
      }
    }
  }
`

const Box = styled(motion.div)`
  width: 70vw;
  background: white;
`

const variants = {
  hidden: { opacity: 0, visibility: "hidden" },
  visible: { opacity: 1, visibility: "visible" },
}
const contentVariants = {
  hidden: { y: "-30%", x: "-50%" },
  visible: { y: "-50%", x: "-50%" },
}

async function Content({ feature, facet }) {
  const navigation = useNavigation()
  const locale = useLocale()

  const f = facetsMap?.[facet] || facet
  const path = navigation.localize(`/term/${feature}.extra.json`, locale.current.codes.www)

  console.log("••• facet", facet)
  console.log("••• f", f)

  const data = await load(path).catch(err => console.log("••• err", err))
  console.log("••• data", data)

  const cleaned = data[1].find(x => x.tech_code === `${feature}-${f}`)

  console.log("••• cleaned", cleaned)

  return <Box>"test"</Box>
}

async function getData({ feature, facet, navigation, locale }) {
  console.log("\n•••••• getData", feature, facet, navigation, locale)
  return
}

const Dialog = forwardRef(function Dialog({ feature, facet }, ref) {
  const navigation = useNavigation()
  const locale = useLocale()

  const dialogRef = useRef()

  useImperativeHandle(ref, () => ({
    open: async () => {
      await getData({ feature, facet, navigation, locale })
      //   animDialog(dialogScope.current, variants.visible, { duration: 0.2 })
      //   animContent(contentScope.current, contentVariants.visible, { duration: 0.2 })
    },
    close: () => {
      //   animDialog(dialogScope.current, variants.hidden, { duration: 0.2 }).then(() => dialogScope.current.close())
      //   animContent(contentScope.current, contentVariants.hidden, { duration: 0.2 })
    },
  }))

  function handleKeyDown(e) {
    if (e.key === "Escape") {
      e.preventDefault()
      onClose()
    }
  }
  function onClose() {
    // ref.current.close()
  }

  return (
    <FocusScope contain restoreFocus autoFocus>
      <ModalContainer onClose={onClose} className={specTerms}>
        <Box initial={contentVariants.hidden}>
          <Suspense fallback={<p>{""}</p>}>{/* <Box feature={feature} facet={facet} /> */}</Suspense>
        </Box>
      </ModalContainer>
    </FocusScope>
  )
})

export default function SpecTermBtn({ content, id }) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const bodyElement = process.browser && document.body

  const ref = useRef()
  console.log("\n•••••• SpecTermBtn", id)
  const arr = id.split("-")
  const feature = arr.shift()
  const facet = arr.join("-")
  console.log("• feature", feature, facet)

  const onClose = () => {
    setIsModalOpen(false)
  }

  const onOpen = () => {
    setIsModalOpen(true)
  }

  return (
    <>
      {process.browser && createPortal(<AnimatePresence>{isModalOpen && <Dialog onClose={onClose} onOpen={onOpen} />}</AnimatePresence>, bodyElement)}
      <Button className='spec-term-btn' onClick={onOpen}>
        {content}
      </Button>
    </>
  )
}
